import React from "react";
import instagramlogo from "../../assets/img/instagram.png";
import facebooklogo from "../../assets/img/facebook.png";
import logodissemp from "../../assets/img/logo.webp";
import { Col, Row } from "react-bootstrap";

const CommunityBanner = () => {
    return (
        <div className="relative bg-black text-white py-16 px-6 md:px-20 redes-sociales">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center text-center md:text-left">
                <Row className="mb-1">
                    <Col md="8">
                        <h2 className="text-5xl md:text-6xl font-extrabold uppercase leading-tight">
                            SÍGUENOS EN REDES <br /> Y ENTÉRATE DE TODO
                        </h2>
                    </Col>
                    <Col md="4" className="text-left">
                        <div>
                            <img
                                src={logodissemp}
                                alt="Tu imagen"
                                className="w-32 md:w-40 rounded-full border-4 border-white"
                                width={"100%"}
                            />
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="flex flex-wrap text-center gap-8 mt-12">
                {[
                    { id: "instagram", img: instagramlogo, link: "https://www.instagram.com/dissemp.academy/" },
                    { id: "facebook", img: facebooklogo, link: "https://www.facebook.com/profile.php?id=61567435371918" },
                ].map((item) => (
                    <a
                        key={item.id}
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="relative w-44 md:w-56 rounded-lg overflow-hidden shadow-lg transform hover:scale-105 transition"
                    >
                        <img
                            src={item.img}
                            width={"30%"}
                            alt="Red social"
                            className="w-full rounded-lg text-center social-icon"
                        />
                        <span className="absolute top-2 right-2 text-3xl">{item.icon}</span>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default CommunityBanner;
